/// <amd-module name="SuiteCommerce.GridOrder.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Item.Model", ["require", "exports", "Backbone", "underscore"], function (require, exports, Backbone_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GridOrderBehavior;
    (function (GridOrderBehavior) {
        GridOrderBehavior["DefaultSiteBehavior"] = "Default Site Behavior";
        GridOrderBehavior["AlwaysActiveForThisItem"] = "Always Active For This Item";
        GridOrderBehavior["DesactivateForThisItem"] = "Desactivate For This Item";
    })(GridOrderBehavior = exports.GridOrderBehavior || (exports.GridOrderBehavior = {}));
    var ItemModel = /** @class */ (function (_super) {
        __extends(ItemModel, _super);
        function ItemModel(itemSchema) {
            return _super.call(this, itemSchema) || this;
        }
        Object.defineProperty(ItemModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemId", {
            get: function () {
                return this.get('itemid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "outStockMessage", {
            get: function () {
                return this.get('outofstockmessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "isShowStockEnabled", {
            get: function () {
                return this.get('custitem_ns_sc_grid_order_show_stock');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "isShowStockNotificationsEnabled", {
            get: function () {
                return this.get('custitem_ns_sc_grid_order_stock_notif');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "onlineCustomerPriceDetails", {
            get: function () {
                return this.get('onlinecustomerprice_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixChildItemsDetail", {
            get: function () {
                return this.get('matrixchilditems_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "gridOrderBehavior", {
            get: function () {
                return this.get('custitem_ns_sc_grid_order_behavior') || GridOrderBehavior.DefaultSiteBehavior;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemOptionsDetails", {
            get: function () {
                return this.get('itemoptions_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixOptions", {
            get: function () {
                var itemOptionsDetails = this.itemOptionsDetails.fields || [];
                return _.filter(itemOptionsDetails, function (itemOption) {
                    return itemOption.ismatrixdimension;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "mandatoryNonMatrixOptions", {
            get: function () {
                var fields = this.itemOptionsDetails.fields || [];
                return _.filter(fields, function (field) {
                    return !field.ismatrixdimension && field.ismandatory;
                });
            },
            enumerable: true,
            configurable: true
        });
        return ItemModel;
    }(Backbone_1.Model));
    exports.ItemModel = ItemModel;
});
